module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-crud-category-multi-select"
  }, [_c('el-select', {
    attrs: {
      "value": _vm.value ? _vm.value.split(',').map(Number) : [],
      "placeholder": "Please select a category",
      "loading": _vm.loading,
      "multiple": ""
    },
    on: {
      "input": _vm.updateValue
    }
  }, _vm._l((_vm.remoteValues), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30240814"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/CategoryMultiSelect.vue
// module id = 529
// module chunks = 1